var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-expand-btn',{staticClass:"alarms-expand-panel-btn",class:_vm.expandButtonClass,attrs:{"expanded":_vm.expanded,"loading":_vm.pending},on:{"expand":_vm.showExpandPanel}})
}
var staticRenderFns = []

export { render, staticRenderFns }